const ModuleRight = () => {
  return <div className="right"></div>;
};

export default ModuleRight;
